<template>
    <v-row no-gutters class="pt-4">
        <v-col cols="12" sm="6" md="2">
            <v-select
                v-model="formData.generalVatPlanId"
                :items="vatPlans"
                :label="$t('end_price_VAT')"
                item-title="name"
                item-value="id"
                clearable
                data-cy="price-VAT"
                class="mb-4"
            />
            <v-select
                v-model="formData.commissionVatPlanId"
                :items="vatPlans"
                :label="$t('commission_VAT')"
                item-title="name"
                item-value="id"
                clearable
                data-cy="commission-VAT"
            />
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()
    const {vatPlans} = useVatPlans()
</script>
